<template src="./main.html"></template>

<script>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import ToolBar from "@/components/layout/ToolBar";
import LeftBar from "@/components/layout/LeftBar";
import LicenzaBanner from "@/components/LicenzaBanner.vue";
import PaginaDemo from "./PaginaDemo.vue";
import { get_mio_abbonamento } from "@/api/api.abbonamento.js";

export default {
  name: "MainPage",
  components: {
    ToolBar,
    LeftBar,
    LicenzaBanner,
    PaginaDemo
  },
  setup() {
    const store = useStore();

    // Reactive state
    const menu = ref([]);
    const disabilitaBtn = ref(false);
    const drawer = ref(true);
    const giorniAllaScadenzaAbbonamento = ref(null);

    // Computed properties
    const loading = computed(() => store.state.app.loading);
    const utente = computed(() => store.getters["user/getNome"]);
    const mail = computed(() => store.getters["user/getMail"]);

    const licenzaStato = computed(() => store.getters['user/getLicenzaStato'])
    const emailConfirmata = computed(() => store.getters['user/getEmailConfirmata'] ?? false)
    const isDemo = computed(() => licenzaStato.value !== 1)


    // Methods
    const init = async () => {
      try {
        // User info
        const res = await store.dispatch("user/userInfo");
        menu.value = res.data.menu;
      } catch (error) {
        console.log(error);
      }
    };

    // Recupera i giorni alla scadenza dell'abbonamento per il banner di avviso rinnovo
    // (mostrato anche ad abbonamento attivo, non solo quando l'accesso è già bloccato)
    const caricaScadenzaAbbonamento = async () => {
      try {
        const res = await get_mio_abbonamento();
        giorniAllaScadenzaAbbonamento.value = res.data ? res.data.giorniAllaScadenza : null;
      } catch {
        giorniAllaScadenzaAbbonamento.value = null;
      }
    };

    const esci = async () => {
      disabilitaBtn.value = true;
      try {
        await store.dispatch("auth/logout");
      } catch (error) {
        console.log(error);
      }
    };
    const role = computed(() => store.getters['user/getRole'])

    const aggiornaRichieste = () => {
      if (role.value >= 2) {  // solo admin/superadmin
        store.dispatch('app/aggiornaRichiestePendenti')
      }
    };

    onMounted(async () => {
      await init();
      aggiornaRichieste();
      // Solo se l'abbonamento è effettivamente attivo ha senso controllarne la scadenza:
      // se non lo è viene mostrata PaginaDemo, non serve questa chiamata aggiuntiva
      if (!isDemo.value) caricaScadenzaAbbonamento();
      setInterval(aggiornaRichieste, 5 * 60 * 1000);

    });

    return {
      menu,
      disabilitaBtn,
      loading,
      utente,
      mail,
      drawer,
      licenzaStato,
      emailConfirmata,
      giorniAllaScadenzaAbbonamento,
      init,
      esci,
      isDemo
    };
  },
};
</script>